import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "@windmill/react-ui";
import { useHistory } from "react-router-dom";

import useIdle from "../../utils/idleTimeout";
import { sessionTimeBeforeIdleInSeconds } from "../../utils/variables";
import { logout } from "../../utils/helpers";

const IdleTimeoutModal = ({ setShowIdleModal, onClose, open }) => {
  // Hooks

  const history = useHistory();

  const { idleTimer } = useIdle({
    onIdle: () => setShowIdleModal(true),
    idleTime: sessionTimeBeforeIdleInSeconds,
    history,
    setShowIdleModal,
  });

  // Methods

  const stay = () => {
    setShowIdleModal(false);
    idleTimer.reset();
  };

  const handleLogout = () => {
    setShowIdleModal(false);
    logout(history);
  };

  return (
    <Modal isOpen={open} onClose={onClose}>
      <ModalHeader>Inactivity Detected</ModalHeader>
      <ModalBody>
        You have been inactive for quite some time now. You will be logged out
        soon.
      </ModalBody>
      <ModalFooter>
        <Button className="w-full sm:w-auto" layout="outline" onClick={stay}>
          Stay
        </Button>
        <Button className="w-full sm:w-auto" onClick={handleLogout}>
          Log Out Now
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default IdleTimeoutModal;
